import React, { useState, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import some from 'lodash/some';
import { ContactPersonProps } from './types';
import {
    validateFirstname,
    validateLastname,
    validateEmail,
    validateMobile,
} from '../../Validation';
import { FormErrorType } from "@sharedComponents/PantaForm/types";
import Panel from "@sharedComponents/Panel";
import Button from "@sharedComponents/Button";
import InputText from "@sharedComponents/InputText";

export const ContactPerson = (props: ContactPersonProps) => {
    const { t } = useTranslation()

    const [formErrors, setFormErrors] = useState<FormErrorType[]>([])

    const _formErrors = formErrors.concat(props.formErrors || [])

    const onChangeFirstname = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value

        props.onChangeValues && props.onChangeValues({ firstname: value })
        setFormErrors(validateFirstname(value, formErrors))
    }

    const onChangeLastname = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value

        props.onChangeValues && props.onChangeValues({ lastname: value })
        setFormErrors(validateLastname(value, formErrors))
    }

    const onChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value

        props.onChangeValues && props.onChangeValues({ email: value })
        setFormErrors(validateEmail(value, false, formErrors))
    }

    const onBlurEmail = () => {
        props.onChangeValues &&
            props.onChangeValues({ email: props.values.email })
        setFormErrors(validateEmail(props.values.email, true, formErrors))
    }

    const onChangeMobile = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value

        props.onChangeValues && props.onChangeValues({ mobile: value })
        setFormErrors(validateMobile(value, formErrors))
    }

    const onChangePhone = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value

        props.onChangeValues && props.onChangeValues({ phone: value })
    }

    return (
        <div className='form-step-wrapper__panel-container'>
            <Panel>
                <h5 className='fields-wrapper__title'>{props.title}</h5>
                {props.pasteButtonText && props.onPaste && (
                    <Button
                        type="secondary"
                        className="copy"
                        text={props.pasteButtonText}
                        onClick={props.onPaste}
                    />
                )}
                <div className='fields-wrapper'>
                    <div className='fields-wrapper__field'>
                        <InputText
                            id={`${props.id}-firstname`}
                            label={t('global.firstname')}
                            required={true}
                            hasError={!!some(_formErrors, ['key', 'firstname'])}
                            value={props.values.firstname || ''}
                            onChange={onChangeFirstname}
                            autoComplete="given-name"
                            maxLength={50}
                        />
                    </div>
                    <div className='fields-wrapper__field'>
                        <InputText
                            id={`${props.id}-lastname`}
                            label={t('global.lastname')}
                            required={true}
                            hasError={!!some(_formErrors, ['key', 'lastname'])}
                            value={props.values.lastname || ''}
                            onChange={onChangeLastname}
                            autoComplete="family-name"
                            maxLength={50}
                        />
                    </div>
                    <div className='fields-wrapper__field'>
                        <InputText
                            id={`${props.id}-email`}
                            label={t('global.email')}
                            value={props.values.email || ''}
                            hasError={!!some(_formErrors, ['key', 'email'])}
                            required={true}
                            onChange={onChangeEmail}
                            onBlur={onBlurEmail}
                            type="email"
                            autoComplete="email"
                            maxLength={250}
                        />
                    </div>
                    <div className='fields-wrapper__field'>
                        <InputText
                            id={`${props.id}-mobile`}
                            label={t('global.mobileNumber')}
                            required={true}
                            hasError={!!some(_formErrors, ['key', 'mobile'])}
                            value={props.values.mobile || ''}
                            onChange={onChangeMobile}
                            autoComplete="tel"
                            maxLength={30}
                        />
                    </div>
                    <div className='fields-wrapper__field'>
                        <InputText
                            id={`${props.id}-phone`}
                            label={t('global.phoneNumber')}
                            value={props.values.phone || ''}
                            onChange={onChangePhone}
                            autoComplete="tel"
                            maxLength={30}
                        />
                    </div>
                </div>
            </Panel>
        </div>
    )
}

export default ContactPerson